export default __webpack_public_path__ + "app/modules/linshare.token/images/token-dialog-icon.svg";